function getCaptionValue(property, inLightbox = false) {
  if (!property) {
    return void 0;
  }
  if (inLightbox) {
    if (property.showInContext || property.showOutsideContext) {
      return property.value;
    }
  } else {
    if (property.showInContext) {
      return property.value;
    }
  }
}

export { getCaptionValue };
//# sourceMappingURL=typings.component-caption.js.map
